<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: [Number, String],
      default: 38, // valeur par défaut en px
    },
    color: {
      type: String,
      default: 'var(--color-primary)',
    },
    trackColor: {
      type: String,
      default: 'var(--color-primary)', // couleur du fond du cercle
    },
    strokeWidth: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    computedSize() {
      return typeof this.size === 'number' ? this.size : parseInt(this.size, 10);
    },
    spinnerStyle() {
      return {
        width: `${this.computedSize}px`,
        height: `${this.computedSize}px`,
      };
    },
    headColor() {
      return this.color;
    },
  },
};
</script>
<template>
  <div class="my-spinner" :style="spinnerStyle" role="status" aria-label="Loading">
    <svg :width="computedSize" :height="computedSize" viewBox="0 0 50 50" class="spinner-svg">
      <circle
        class="spinner-track"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-opacity="0.15"
        :stroke="trackColor"
        :stroke-width="strokeWidth" />
      <circle
        class="spinner-head"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        :stroke="headColor"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-dasharray="31.4 94.2"
        stroke-dashoffset="0" />
    </svg>
  </div>
</template>
<style scoped>
.my-spinner {
  display: inline-block;
}

.spinner-svg {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-head {
  transform-origin: center;
}
</style>
